import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dsp-selector"
export default class extends Controller {
  static targets = ["checkbox", "selectedField"]

  connect() {
    // Update hidden field based on currently checked boxes
    // (boxes are pre-checked by server-side rendering based on selected_dsps)
    this.updateHiddenField()

    // Also update on form submit to ensure we capture the latest state
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', () => {
        this.updateHiddenField()
      })
    }
  }

  updateSelection(event) {
    this.updateHiddenField()
  }

  updateHiddenField() {
    const selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => parseInt(checkbox.value))

    // Try to find the hidden field using Stimulus target first, fallback to ID
    let hiddenField
    if (this.hasSelectedFieldTarget) {
      hiddenField = this.selectedFieldTarget
    } else {
      hiddenField = document.getElementById("album_selected_dsps")
    }

    if (hiddenField) {
      hiddenField.value = JSON.stringify(selectedIds)
    } else {
      console.error('Hidden field not found (tried both target and #album_selected_dsps)')
    }
  }

  // Only the rows on screen. A DSP hidden because it has no FUGA id must not
  // be swept up by "select all".
  get visibleCheckboxes() {
    return this.checkboxTargets.filter(checkbox => !checkbox.closest(".hidden"))
  }

  selectAll(event) {
    event.preventDefault()
    this.visibleCheckboxes.forEach(checkbox => {
      checkbox.checked = true
    })
    this.updateHiddenField()
    return false
  }

  deselectAll(event) {
    event.preventDefault()
    this.visibleCheckboxes.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateHiddenField()
    return false
  }
}
